import ResourceTyped from './ResourceTyped';

export type FinancialAnalysisResult = {
	positive: string;
	negative: string;
	risks: string;
	recommendations: string;
	prospectingId: string;
};

class FinancialAnalysis extends ResourceTyped<FinancialAnalysisResult> {
	constructor() {
		super('financialAnalysis');
	}
}

export default new FinancialAnalysis();
